import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Styles
import styles from '../index.module.sass';

// Images
import TRIANGLE from '../../../images/menu/triangle.png';

export default function Item({ index, val, history }) {
  const { location = {} } = history;
  const { hash = '' } = location;
  const [itemSelected, setItemSelected] = useState(false);
  const { id = '', url = '', children = [] } = val || {};

  const { t } = useTranslation('menuheader');

  let itemTimeout;

  const cont = process.env.REACT_APP_COUNTRY;

  return (
    <div
      className={styles.departamentContainer}
      onMouseEnter={() => {
        clearTimeout(itemTimeout);
        setItemSelected(true);
      }}
      onMouseLeave={() => {
        itemTimeout = setTimeout(function () {
          setItemSelected(false);
        }, 100);
      }}
      onClick={() => {
        if (itemSelected) setItemSelected(false);
        else setItemSelected(true);
      }}
      style={{
        order: val.index,
      }}>
      <Link
        to={`${url}${hash}`}
        className={`${styles.departament} ${styles[itemSelected]} ${
          children.length > 0 && styles.haveChildren
        }`}
        onClick={(e) => {
          if (children.length > 0) e.preventDefault();
        }}>
        <span>{t(id)}</span>
        {children.length > 0 && (
          <div>
            <span className={`material-icons-outlined ${styles.itemIcon}`}>expand_more</span>
          </div>
        )}
      </Link>
      <div className={styles.borderBottom}></div>
      <div className={`${styles.families} ${styles[itemSelected && children.length > 0]}`}>
        <img src={TRIANGLE} alt='' className={styles.triangle} />
        {children.map((subval, subkey) => {
          const external = (
            <a
              className={styles.familyTitle}
              key={subkey}
              href={`${subval.url}`}
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => {
                setItemSelected(false);
              }}>
              <span className={`material-icons ${styles.familyIcon}`}>
                {subval?.icon || 'arrow_right_alt'}
              </span>
              <div>{t(subval.id)}</div>
            </a>
          );

          const normal = (
            <Link
              className={styles.familyTitle}
              key={subkey}
              to={`${url}${subval.url}${hash}`}
              onClick={() => {
                setItemSelected(false);
              }}>
              <span className={`material-icons ${styles.familyIcon}`}>
                {subval?.icon || 'arrow_right_alt'}
              </span>
              <div>{t(subval.id)}</div>
            </Link>
          );
          if (subval.external) {
            if (subval.country && subval.country === cont) return external;
            else if (subval.country && subval.country !== cont) return null;
            else return external;
          } else {
            if (subval.country && subval.country === cont) return normal;
            else if (subval.country && subval.country !== cont) return null;
            else return normal;
          }
        })}
      </div>
    </div>
  );
}
